module.exports = __webpack_public_path__ + "static/media/on-eye_fresh-SheerDream.b3e09e50.jpg";